import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RestApiService } from './api/rest-api.service';

@NgModule({
  providers: [RestApiService],
})
export class CoreModule {}
